// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header styles */

.headerParent {
  background-color: #322217;
  height: "20vh";
  display: flex;
  justify-content: space-between;
  padding: 2vw;
}

#header-text {
  font-size: xx-large;
  color: #ebdfcc;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA,kBAAkB;;AAElB;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["/* Header styles */\n\n.headerParent {\n  background-color: #322217;\n  height: \"20vh\";\n  display: flex;\n  justify-content: space-between;\n  padding: 2vw;\n}\n\n#header-text {\n  font-size: xx-large;\n  color: #ebdfcc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
